module.exports = __webpack_public_path__ + "static/media/file5.ce8dbfe7.png";